module.exports = __webpack_public_path__ + "img/food_detail_2.e6c24360.svg";